import { useEffect, useState } from "react";
//import { get } from "../utils/httpApi";
import SearchAutocomplete from "./flightStatus/search-autocomplete";
import { buildIndex } from "./flightStatus/airportsMap";
import locations from "./flightStatus/airports.json";
import TwoMonthsPicker1 from "../utils/dateRange";
import { useContext } from "react";
import { FlightContext } from "../utils/flightContext";
import ExchangeInputs from "./flightStatus/exchange";
import styles from "./Book1.module.css";
import NumPassenger from "./flightStatus/numPassenger";
import TripSelector from "./flightStatus/tripTypeSelector";
import { useMediaQuery } from "react-responsive";

const findAirportByCode = (airportCode) => {
  for (const country of Object.keys(locations)) {
    for (const region of Object.keys(locations[country])) {
      const airport = locations[country][region].find(
        ({ iataCode }) => iataCode === airportCode
      );

      if (airport) {
        return {
          label: airport.iataCode,
          details: {
            country,
            region,
            airport,
          },
        };
      }
    }
  }

  return {
    label: airportCode,
    details: null,
  };
};

const DEFAULT_DEPART_CITY = findAirportByCode("MIA");

export function Book({
  setSearchData,
  searchData,
  setUniqueOffers,
  data,
  handleSearch,
  setShowBook,
}) {
  const [ctdadPassenger, setCtdadPassenger] = useState(1);
  const [index, setIndex] = useState(null);
  const start = new Date();
  start.setDate(start.getDate() + 1);
  const end = new Date();
  end.setDate(end.getDate() + 4);
  const [startDate, setStartDate] = useState(start);
  const [endDate, setEndDate] = useState(end);

  const { setFlightInformation, flightInformation } = useContext(FlightContext);

  const [secondRange, setSecondRange] = useState(false); //Para el comportamiento del rango de fechas
  const [customError, setCustomError] = useState("");
  const [error, setError] = useState(false);
  const isMobile = useMediaQuery({ maxWidth: 990 });
  const emptyCity = { label: "", details: null };

  const [formState, setFormState] = useState({
    departCity: flightInformation.departCity?.label
      ? flightInformation.departCity
      : DEFAULT_DEPART_CITY,
    returnCity: flightInformation.returnCity || emptyCity,
  });
  
  const [tripType, setTripType] = useState("Roundtrip");

  // Función para manejar el cambio de tipo de viaje
  const handleTripTypeChange = (newTripType) => {
    setTripType(newTripType);
  };


  useEffect(() => {
    const builtIndex = buildIndex(locations);
    setIndex(builtIndex);
  }, []);

  //////////To know if it is a manual page reload////////////
  useEffect(() => {
    const handleBeforeUnload = () => {
      sessionStorage.setItem("manualReload", "true"); // Marcar recarga manual
    };
    // Escuchar el evento de recarga manual
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      // Limpiar el listener cuando el componente se desmonte
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  //////////Para saber si es un reinicio de pagina manual////////////
  useEffect(() => {
    const isManualReload = sessionStorage.getItem("manualReload") === "true";
    if (isManualReload) {
      // se detectó una recarga manual, resetear el estado
      //localStorage.removeItem("storeData");
      //setSearchData(false);
      sessionStorage.removeItem("manualReload"); // Limpiar la bandera de recarga
      localStorage.removeItem("flightInformation");
      localStorage.removeItem("returnOffers");
      localStorage.removeItem("searchResults");
      localStorage.removeItem("searchData");
      setSearchData(false);
      setFlightInformation({
        departCity: DEFAULT_DEPART_CITY,
        returnCity: {},
        dateDepart: "",
        dateReturn: "",
        passengers: 1,
        currencyCode: "USD",
        includedAirlineCodes: "UA,NK,AC,AS,B6,F9,HA,WN",
        nonStop: false,
        tripType: "Roundtrip",
      });
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (flightInformation.departCity?.label) {
      return;
    }

    const savedFlightInformation = JSON.parse(
      localStorage.getItem("flightInformation")
    );

    if (savedFlightInformation) {
      return;
    }

    setFlightInformation((prev) => {
      const updated = {
        ...prev,
        departCity: DEFAULT_DEPART_CITY,
      };

      localStorage.setItem("flightInformation", JSON.stringify(updated));
      return updated;
    });
  }, [flightInformation.departCity?.label, setFlightInformation]);

  useEffect(() => {
    const savedFlightInformation = JSON.parse(
      localStorage.getItem("flightInformation")
    );
    const today = new Date();
    today.setHours(0, 0, 0, 0); // Ignora la hora, solo compara fechas

    if (savedFlightInformation) {
      const normalizedSavedFlightInformation = {
        ...savedFlightInformation,
        includedAirlineCodes:
          savedFlightInformation.includedAirlineCodes || "UA,NK,AC,AS,B6,F9,HA,WN",
        nonStop: false,
        tripType: savedFlightInformation.tripType || "Roundtrip",
      };
      const depDate = new Date(savedFlightInformation.dateDepart);
      const retDate = new Date(savedFlightInformation.dateReturn);

      const isDepPast = depDate < today;
      const isRetPast = retDate < today;

      if (isDepPast || isRetPast) {
        // ⚠️ Fechas caducadas, las reemplazamos con nuevas válidas
        const newStart = new Date();
        newStart.setDate(newStart.getDate() + 1);
        const newEnd = new Date();
        newEnd.setDate(newEnd.getDate() + 4);

        const updated = {
          ...normalizedSavedFlightInformation,
          dateDepart: newStart,
          dateReturn: newEnd,
        };

        setFlightInformation(updated);
        localStorage.setItem("flightInformation", JSON.stringify(updated));
        setStartDate(newStart);
        setEndDate(newEnd);
        setCtdadPassenger(updated.passengers || 1);
      } else {
        // ✅ Fechas válidas, usamos las del storage
        setFlightInformation(normalizedSavedFlightInformation);
        localStorage.setItem(
          "flightInformation",
          JSON.stringify(normalizedSavedFlightInformation)
        );
        setStartDate(depDate);
        setEndDate(retDate);
        setCtdadPassenger(normalizedSavedFlightInformation.passengers || 1);
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (
      !flightInformation.departCity.label ||
      !flightInformation.returnCity.label
    ) {
      setCustomError("Both departure and return locations must be filled.");
    }
    if (
      flightInformation.departCity.label ===
        flightInformation.returnCity.label &&
      flightInformation.departCity.label
    ) {
      setCustomError("Locations cannot be the same");
      setError(true);
    } else {
      setCustomError(""); // Limpia el error si todo está bien
      setError(false);
    }
  }, [flightInformation.departCity.label, flightInformation.returnCity.label]);

  const handleSubmit = (e) => {
    e.preventDefault();

    const updatedFlightInformation = {
      ...flightInformation,
      departCity: formState.departCity,
      returnCity: formState.returnCity,
      dateDepart: startDate,
      dateReturn: tripType === "Roundtrip" ? endDate : null, // Solo incluir returnDate si es Roundtrip
      passengers: ctdadPassenger,
      currencyCode: flightInformation.currencyCode || "USD",
      includedAirlineCodes: "UA,NK,AC,AS,B6,F9,HA,WN",
      nonStop: false,
      tripType: tripType, // Agregar el tipo de viaje
    };
    // Actualiza el contexto y localStorage antes de navegar
    setFlightInformation(updatedFlightInformation);
    localStorage.setItem(
      "flightInformation",
      JSON.stringify(updatedFlightInformation)
    );
    handleSearch(updatedFlightInformation);
  };

  useEffect(() => {
    // Solo si no hay fechas guardadas
    if (
      !flightInformation.dateDepart ||
      !flightInformation.dateReturn ||
      !(flightInformation.dateDepart instanceof Date)
    ) {
      const updated = {
        ...flightInformation,
        dateDepart: startDate,
        dateReturn: endDate,
        passengers: ctdadPassenger,
        currencyCode: flightInformation.currencyCode || "USD",
        includedAirlineCodes: "UA,NK,AC,AS,B6,F9,HA,WN",
        nonStop: false,
      };

      setFlightInformation(updated);
      localStorage.setItem("flightInformation", JSON.stringify(updated));
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Manejar cambio de tipo de viaje
  useEffect(() => {
    if (tripType === "One-way") {
      // Si cambia a one-way, limpiar la fecha de regreso
      setEndDate(null);
    } else if (tripType === "Roundtrip" && !endDate) {
      // Si cambia a round trip y no hay fecha de regreso, establecer una por defecto
      const defaultEnd = new Date(startDate);
      defaultEnd.setDate(startDate.getDate() + 3);
      setEndDate(defaultEnd);
    }
  }, [tripType, startDate, endDate]);


  return (
    <div
      className={`${styles.chooseContainer} ${searchData ? styles.filter : ""}`}
    >
      {!searchData && (
        <div className={styles.chooseTitle}>
          <h1>BOOK A FLIGHT</h1>
          <div className={styles.chooseTitleBorder}></div>
        </div>
      )}
      <form
        className={`${styles.formContainer} ${styles.filter}`}
        onSubmit={handleSubmit}
      >
        <TripSelector onTripTypeChange={handleTripTypeChange} />
        <div className={styles.flightSearch}>
          <div className={styles.searchContainer}>
            <div className={styles.searchAutocomplete}>
              <SearchAutocomplete
                key={formState.departCity.label + "-depart"}
                className={styles.iataCode}
                index={index}
                onSearchChange={(newCity) => {
                  setFormState((prev) => ({
                    ...prev,
                    departCity:
                      newCity && newCity.airport
                        ? { label: newCity.airport.iataCode, details: newCity }
                        : { label: "", details: null },
                       
                  }));
                }}
                initialValue={formState.departCity.label}
                place="Leaving to"
              />
              {/* Display custom error if `return` and `depart` are the same */}
              {customError && (
                <p
                  style={{ color: "red", fontSize: "14px" }}
                  className={styles.searchError}
                >
                  {customError}
                </p>
              )}
            </div>
            <ExchangeInputs
              error={error}
              formState={formState}
              setFormState={setFormState}
            />
            <div className={styles.searchAutocomplete}>
              <SearchAutocomplete
                key={formState.returnCity.label + "-return"}
                className={styles.iataCode}
                index={index}
                onSearchChange={(newCity) => {
                  setFormState((prev) => ({
                    ...prev,
                    returnCity:
                      newCity && newCity.airport
                        ? { label: newCity.airport.iataCode, details: newCity }
                        : { label: "", details: null },
                  }));
                }}
                initialValue={formState.returnCity.label}
                place="Going to"
              />
              {/* Display custom error if `return` and `depart` are the same */}
              {customError && (
                <p
                  style={{ color: "red", fontSize: "14px" }}
                  className={styles.searchError}
                >
                  {customError}{" "}
                </p>
              )}
            </div>
          </div>
          <TwoMonthsPicker1
            minDate={new Date()}
            start={startDate}
            startDate={startDate}
            setStartDate={setStartDate}
            //maxDate={maxDate}
            endDate={endDate}
            tripType={tripType} // Pasar el tipo de viaje
            onChangeDate={(dates) => {
              if (tripType === "One-way") {
                // Para one-way, dates es una sola fecha, no un array
                const selectedDate = dates;
                setStartDate(selectedDate);
                setEndDate(null); // No hay fecha de regreso
              } else {
                // Para round trip, dates es un array [start, end]
                const [start, end] = dates;
                if (endDate && start > endDate && secondRange === false) {
                  setEndDate(start);
                  setSecondRange(!secondRange);
                } else if (endDate && start < startDate) {
                  setStartDate(start);
                  const newEndDate = new Date(start);
                  newEndDate.setDate(newEndDate.getDate() + 1);
                  setEndDate(newEndDate);
                  setSecondRange(false);
                } else {
                  setStartDate(start);
                  setEndDate(end);
                  setSecondRange(false);
                }
              }
            }}
          />
          <NumPassenger />
          <div>
            <button type="submit" className={styles.searchButton}>
              <span className={styles.buttonText}>Search</span>
            </button>
          </div>
        </div>
      </form>
      {isMobile && searchData && (
        <button
          type="submit"
          className={styles.buttonCloseBook}
          onClick={() => setShowBook(false)}
        >
          Close
        </button>
      )}
    </div>
  );
}
